const state = () => ({
  status: 200, // 200 404 408
  type: "tv",
  corpId: 0,
  channelInfo: {},
  menuList: [],
  playerInfo: { playUrl: "", saveUrl: "", cameraId: "" },
  wechatInfo: {},
  userInfo: {},
  uuid: '',
  playerAddress: null,
  drainage: {},
});
export default state;
